<template>
	<div>
		<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent" ref="supplierlevellogtable"></vxe-grid>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			currentRow: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {
			currentRow(){
				this.$refs.supplierlevellogtable.commitProxy('query')
			}
		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.height = 180
				gridOptions.toolbarConfig.enabled = false
				gridOptions.columns = [{
						field: 'newlevel',
						title: '变更后评级',
					},
					{
						field: 'oldlevel',
						title: '变更前评级'
					},
					{
						field: 'create_time',
						title: '变更时间',
					}
				]
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					let data = []
					this.$api.supplier.log({
						type:'等级变更',
						supplierid:this.currentRow.id,
					}).then((res)=>{
						res.forEach((item)=>{
							data.push({
								oldlevel:item.param.oldlevel,
								newlevel:item.param.newlevel,
								create_time:this.$Moment(item.create_time * 1000).format('YYYY-MM-DD')
							})
						})	
					})
					console.log(data)
					resolve({
						list: data
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>